import template from './change-password.html';
import controller from './change-password.controller';

let changePasswordComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default changePasswordComponent;
